import { ChipLight } from '@juvare/common-web-ui/ChipLight';
import { Box, Typography } from '@mui/material';
import React from 'react';
import { LinkWithArrow } from '../../../../ui/components/LinkWithArrow';
import { useMissionsTranslation } from '../../../../ui/hooks';
import { themeColors } from '@juvare/common-web-ui/JuvareTheme';
import { useMissionTab } from '../../mission/hooks/useMissionTab';
import { MissionDetailsPlaceholders } from './MissionDetailsPlaceholders';
export const MissionDetails = ({ missionId, missionName, missionType, missionStatus, placeHolders, descriptionId, detailsDescriptionId, }) => {
    const { t } = useMissionsTranslation();
    const { missionTab } = useMissionTab();
    const linkToMissionDetails = `${missionId}?missionTab=${missionTab}`;
    return (React.createElement(LinkWithArrow, { ariaDescribedBy: descriptionId, to: linkToMissionDetails, ariaLabel: t('missions.detailsMissionAriaLabel', { missionName }) },
        React.createElement(Box, { id: detailsDescriptionId !== null && detailsDescriptionId !== void 0 ? detailsDescriptionId : descriptionId, p: 2, sx: {
                width: '100%',
                display: 'flex',
                flexDirection: { xs: 'column', lg: 'row' },
                alignItems: 'center',
                gap: 2,
            } },
            React.createElement(Box, { sx: { display: 'flex', flexDirection: 'column', width: '100%' } },
                React.createElement(Box, { sx: { display: 'flex', flexWrap: 'wrap', gap: 1 } },
                    React.createElement(Typography, { variant: 'h6', "data-test": 'mission-title' },
                        missionName,
                        missionStatus === 'draft' && React.createElement(ChipLight, { sx: { ml: 1 }, label: t('missions.status.draft') }))),
                React.createElement(Typography, { variant: 'subtitle2', sx: { color: themeColors.text.subtle }, "data-test": 'mission-type' }, missionType)),
            React.createElement(Box, { sx: { width: '100%', alignSelf: 'flex-start' } }, React.createElement(MissionDetailsPlaceholders, { placeHolders: placeHolders })))));
};
